import { getFeatureToggleClient } from '../../misc/featureToggles';
export function isVerifyClientDataToggleEnabled() {
  return getFeatureToggleClient().variation('DocumentsAPI.VerifyClientData', false);
}
//# sourceMappingURL=verifyClientDataToggle.js.map
